// extracted by css-extract-rspack-plugin
export default {"pillHalf":"pillHalf-VjCL20","pillHalfAttached":"pillHalfAttached-ZnVFCr","group":"group-Z2R3H_","themedMenuTrigger":"themedMenuTrigger-Q0bObX"};